"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templateContentsAddApi = templateContentsAddApi;
exports.templateContentsBulkHardDeleteApi = templateContentsBulkHardDeleteApi;
exports.templateContentsBulkRestoreApi = templateContentsBulkRestoreApi;
exports.templateContentsBulkSoftDeleteApi = templateContentsBulkSoftDeleteApi;
exports.templateContentsDeleteApi = templateContentsDeleteApi;
exports.templateContentsFetchApi = templateContentsFetchApi;
exports.templateContentsListApi = templateContentsListApi;
exports.templateContentsSoftDeleteApi = templateContentsSoftDeleteApi;
exports.templateContentsSoftDeleteRestoreApi = templateContentsSoftDeleteRestoreApi;
exports.templateContentsSoftDeletedListApi = templateContentsSoftDeletedListApi;
exports.templateContentsUpdateApi = templateContentsUpdateApi;
exports.templateReportContentsBulkHardDeleteApi = templateReportContentsBulkHardDeleteApi;
exports.templateReportContentsBulkRestoreApi = templateReportContentsBulkRestoreApi;
exports.templateReportContentsBulkSoftDeleteApi = templateReportContentsBulkSoftDeleteApi;
exports.templateReportContentsDeleteApi = templateReportContentsDeleteApi;
exports.templateReportContentsFetchApi = templateReportContentsFetchApi;
exports.templateReportContentsSoftDeleteApi = templateReportContentsSoftDeleteApi;
exports.templateReportContentsSoftDeleteRestoreApi = templateReportContentsSoftDeleteRestoreApi;
exports.templateReportContentsSoftDeletedListApi = templateReportContentsSoftDeletedListApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function templateContentsFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.fetch), params);
}

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function templateReportContentsFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.reportFetch), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
function templateContentsListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.list), params);
}

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function templateContentsAddApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.add), payload);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function templateContentsUpdateApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.update), payload);
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
function templateContentsDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.delete), params);
}

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
function templateContentsSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.softDelete), params);
}

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft dalete restore data.
 */
function templateContentsSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.softDeleteRestore), params);
}

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft daleted list data.
 */
function templateContentsSoftDeletedListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.softDeletedList), params);
}

/**
 * bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk soft dalete data.
 */
function templateContentsBulkSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.bulkSoftDelete), params);
}

/**
 * bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to bulk hard dalete data.
 */
function templateContentsBulkHardDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.bulkHardDelete), params);
}

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
function templateContentsBulkRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.bulkRestore), params);
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
function templateReportContentsDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.deleteReport), params);
}

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
function templateReportContentsSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.softDeleteReport), params);
}

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft dalete restore data.
 */
function templateReportContentsSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.softDeleteRestoreReport), params);
}

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft daleted list data.
 */
function templateReportContentsSoftDeletedListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.softDeletedListReport), params);
}

/**
 * bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk soft dalete data.
 */
function templateReportContentsBulkSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.bulkSoftDeleteReport), params);
}

/**
 * bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to bulk hard dalete data.
 */
function templateReportContentsBulkHardDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.bulkHardDeleteReport), params);
}

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
function templateReportContentsBulkRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.templateContents.bulkRestoreReport), params);
}